
import { cache } from "react";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
import { getProjectSpecificData } from "@packages/lib/utlils/commonFunction";
import { defaultPageNo, SortOptions, REVIEWS_PER_PAGE } from "@packages/models/university-course-reviews/review.model";
import { graphQlFetchFunction } from "@packages/lib/server-actions/server-action";
import { getInstitutionReviewMetaQuery } from "@packages/lib/graphQL/graphql-query";

export const getUniversityDetails = cache(async (uniId: number, studyLevel = 'undergraduate') => {
    const universityDetails = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.universityReviewDetails}`,
        method: "GET",
        headers: {
            "x-api-key": process.env.NEXT_PUBLIC_X_API_KEY!,
            sitecode: String(process.env.SITE_CODE),
        },
        queryParams: {
            institutionId: uniId,
            affiliateId: getProjectSpecificData("affiliateId"),
            networkId: studyLevel?.toLocaleLowerCase() === 'undergraduate' ? 2 : 3
        }
    });
    return universityDetails;
});

export const getUniversityReviewContent = async (queryParams: any) => {
    const parts: string[] = [];
    if (queryParams.subjects) parts.push("SUBJECT");
    if (queryParams.studyLevel) parts.push("STUDY_LEVEL");
    const seoFieldsName = parts.length > 0 ? `SEO - RP + ${parts.join(" + ")}` : "SEO - RP";
    return graphQlFetchFunction(getInstitutionReviewMetaQuery("/university-review/whatuni", seoFieldsName.trim()))
};

export const getReviewHelpfulDetails = async (reviewIds: any) => {
    const helpfulDetails = makeApiCall({
        url: `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.reviewHelpfulDetails}`,
        method: "POST",
        headers: {
            "x-api-key": process.env.NEXT_PUBLIC_X_API_KEY!,
            sitecode: String(process.env.SITE_CODE),
        },
        body: {reviewIds,
            affiliateId: getProjectSpecificData("affiliateId")
        }
    });
    return helpfulDetails;
}

export const getUniversityUserReviews = async (uniId: number, queryParams: any = {}) => {
    queryParams = {
        ...queryParams,
        pageNo: queryParams.pageno || queryParams.pageNo || defaultPageNo,
        pageSize: REVIEWS_PER_PAGE,
        sortBy: queryParams.sortBy || SortOptions.Latest
    }
    // Remove the URL-facing 'pageno' key as API expects 'pageNo'
    delete queryParams.pageno;
    // Remove undefined keys
    Object.keys(queryParams).forEach(key =>
        queryParams[key] === undefined && delete queryParams[key]
    );

    // Decode query parameters and fix + separator
    Object.keys(queryParams).forEach(key => {
        if (typeof queryParams[key] === 'string') {
            queryParams[key] = decodeURIComponent(queryParams[key]).replace(/ /g, '+');
        }
    });

    const userReviewDetail = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.universityReviews}`,
        method: "GET",
        headers: {
            "x-api-key": process.env.NEXT_PUBLIC_X_API_KEY!,
            sitecode: String(process.env.SITE_CODE),
        },
        queryParams: {
            institutionId: uniId,
            affiliateId: getProjectSpecificData("affiliateId"),
            networkId: queryParams?.studyLevel?.toLocaleLowerCase() === 'postgraduate' ? 3 : 2,
            ...queryParams
        }
    });
    return userReviewDetail;
};

export const getReviewSubjects = cache(async (uniId: number) => {
    const reviewSubjects = await makeApiCall({
        url: `${process.env.NEXT_PUBLIC_BFF_API_DOMAIN}${API_URL?.reviewSubjects}`,
        method: "GET",
        headers: {
            "x-api-key": process.env.NEXT_PUBLIC_X_API_KEY!,
            sitecode: String(process.env.SITE_CODE),
        },
        queryParams: {
            institutionId: uniId,
            affiliateId: getProjectSpecificData("affiliateId"),
            networkId: 1
        }
    });
    return reviewSubjects;
});

